import { Action } from '@ngrx/store';
import { Reference } from 'src/app/core/utils/action-helper.util';
import {
  ChangeUserPasswordPayload,
  ImpersonateUserPayload,
  SendPasswordRecoveryMailPayload,
} from '../../_models/settings.models';

/**
 * Application User action types
 */
export enum ApplicationUsersActionTypes {
  LOAD_APPLICATION_USERS = '[Application Users] Load Application Users',
  LOAD_APPLICATION_USERS_SUCCESS = '[Application Users] Load Application Users Success',
  LOAD_APPLICATION_USERS_FAILED = '[Application Users] Load Application Users Failed',
  LOAD_PRODUCTS = '[Application Users] Load Products',
  LOAD_PRODUCTS_SUCCESS = '[Application Users] Load Products Success',
  LOAD_PRODUCTS_FAILED = '[Application Users] Load Products Failed',
  LOAD_COMPANY_USERS = '[Application Users] Load Company Users',
  LOAD_COMPANY_USERS_SUCCESS = '[Application Users] Load Company Users Success',
  LOAD_COMPANY_USERS_FAILED = '[Application Users] Load Company Users Failed',
  LOAD_ENTITY_USERS = '[Application Users] Load Entity Users',
  ADD_EXISTING_USER = '[Application Users] Add Existing User',
  ADD_EXISTING_USER_SUCCESS = '[Appication Users] Add Existing User Success',
  ADD_EXISTING_USER_FAILED = '[Application Users] Add Existing User Failed',
  INVITE_USER = '[Application Users] Invite User',
  INVITE_USER_SUCCESS = '[Application Users] Invite User Success',
  INVITE_USER_FAILED = '[Application Users] Invite User Failed',
  RESEND_INVITE = '[Application Users] Resend Invite',
  RESEND_INVITE_SUCCESS = '[Application Users] Resend Invite Success',
  RESEND_INVITE_FAILED = '[Application Users] Resend Invite Failed',
  DELETE_INVITE = '[Application Users] Delete Invite',
  DELETE_INVITE_SUCCESS = '[Application Users] Delete Invite Success',
  DELETE_INVITE_FAILED = '[Application Users] Delete Invite Failed',
  DELETE_APPLICATION_USER = '[Application Users] Delete Application User',
  DELETE_APPLICATION_USER_SUCCESS = '[Application Users] Delete Application User Success',
  DELETE_APPLICATION_USER_FAILED = '[Application Users] Delete Application User Failed',
  UPDATE_APPLICATION_USER = '[Application Users] Update Application User',
  UPDATE_APPLICATION_USER_SUCCESS = '[Application Users] Update Application User Success',
  UPDATE_APPLICATION_USER_FAILED = '[Application Users] Update Application User Failed',
  SEND_PASSWORD_RECOVERY_MAIL = '[Application Users] Send Password Recovery Mail',
  SEND_PASSWORD_RECOVERY_MAIL_SUCCESS = '[Application Users] Send Password Recovery Mail Success',
  SEND_PASSWORD_RECOVERY_MAIL_FAILED = '[Application Users] Send Password Recovery Mail Failed',
  CHANGE_USER_PASSWORD = '[Application Users] Change User Password',
  CHANGE_USER_PASSWORD_SUCCESS = '[Application Users] Change User Password Success',
  CHANGE_USER_PASSWORD_FAILED = '[Application Users] Change User Password Failed',
  IMPERSONATE_USER = '[Application Users] Impersonate User',
  IMPERSONATE_USER_SUCCESS = '[Application Users] Impersonate User Success',
  IMPERSONATE_USER_FAILED = '[Application Users] Impersonate User Failed',
  RETURN_TO_SUPER_ADMIN = '[Side Bar] Return To Super Admin',
  RETURN_TO_SUPER_ADMIN_SUCCESS = '[Side Bar] Return To Super Admin Success',
  RETURN_TO_SUPER_ADMIN_FAILED = '[Side Bar] Return To Super Admin Failed',
  CREATE_NEW_USER = '[Application Users] Create New User',
  CREATE_NEW_USER_SUCCESS = '[Appication Users] Create New User Success',
  CREATE_NEW_USER_FAILED = '[Application Users] Create New User Failed',
  VALID_USER_EMAIL = '[Application Users] Valid User Email',
  VALID_USER_EMAIL_SUCCESS = '[Appication Users] Valid User Email Success',
  VALID_USER_EMAIL_FAILED = '[Application Users] Valid User Email Failed',
  RESET = '[Application Users] RESET',
}

/**
 * Operations
 */
export class LoadApplicationUsers implements Action {
  readonly type = ApplicationUsersActionTypes.LOAD_APPLICATION_USERS;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public applicationId: string, public force: boolean = false) {}
}

export class LoadApplicationUsersSuccess implements Action {
  readonly type = ApplicationUsersActionTypes.LOAD_APPLICATION_USERS_SUCCESS;

  constructor(public tableId: string, public payload: Array<any>) {}
}

export class LoadApplicationUsersFailed implements Action {
  readonly type = ApplicationUsersActionTypes.LOAD_APPLICATION_USERS_FAILED;

  constructor(public payload: Error) {}
}

export class LoadProducts implements Action {
  readonly type = ApplicationUsersActionTypes.LOAD_PRODUCTS;

  constructor() {}
}

export class LoadProductsSuccess implements Action {
  readonly type = ApplicationUsersActionTypes.LOAD_PRODUCTS_SUCCESS;

  constructor(public payload: Array<any>) {}
}

export class LoadProductsFailed implements Action {
  readonly type = ApplicationUsersActionTypes.LOAD_PRODUCTS_FAILED;

  constructor(public error: any) {}
}

export class LoadCompanyUsers implements Action {
  readonly type = ApplicationUsersActionTypes.LOAD_COMPANY_USERS;

  constructor(
    public companyId: any,
    public applicationId: any,
    public isSearch: boolean,
    public search: string,
    public isScroll: boolean,
    public skip: number,
    public pageSize: number,
    public isOptimizedComponent: boolean
  ) {}
}

export class LoadEntityUsers implements Action {
  readonly type = ApplicationUsersActionTypes.LOAD_ENTITY_USERS;

  constructor(
    public entityId: string,
    public query: string,
    public skip: number,
    public pageSize: number
  ) {}
}

export class LoadCompanyUserSuccess implements Action {
  readonly type = ApplicationUsersActionTypes.LOAD_COMPANY_USERS_SUCCESS;

  constructor(companyId: any, public payload: Array<any>) {}
}

export class LoadCompanyUserFailed implements Action {
  readonly type = ApplicationUsersActionTypes.LOAD_COMPANY_USERS_FAILED;

  constructor(public error: any) {}
}

/**
 * Add Existing User
 */
export class AddExistingUser extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.ADD_EXISTING_USER;

  constructor(public payload: any) {
    super();
  }
}

/**
 * Add Existing User Success
 */
export class AddExistingUserSuccess extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.ADD_EXISTING_USER_SUCCESS;

  constructor(public appId: any) {
    super();
  }
}

/**
 * Add Existing User Failed
 */
export class AddExistinguserFailed extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.ADD_EXISTING_USER_FAILED;

  constructor(public payload: any) {
    super();
  }
}

/**
 * Delete an Application User
 */
export class DeleteApplicationUser extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.DELETE_APPLICATION_USER;

  constructor(public appId: any, public appUserId: any) {
    super();
  }
}

export class DeleteApplicationUserSuccess extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.DELETE_APPLICATION_USER_SUCCESS;

  constructor(public appId: any) {
    super();
  }
}

export class DeleteApplicationUserFailed extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.DELETE_APPLICATION_USER_FAILED;

  constructor(public payload: any) {
    super();
  }
}

/**
 * Update Application User
 */

export class UpdateApplicationUser extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.UPDATE_APPLICATION_USER;

  constructor(public appId: any, public payload: any) {
    super();
  }
}

export class UpdateApplicationUserSuccess extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.UPDATE_APPLICATION_USER_SUCCESS;
  constructor(public appId: any) {
    super();
  }
}

export class UpdateApplicationUserFailed extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.UPDATE_APPLICATION_USER_FAILED;
  constructor(public payload: any) {
    super();
  }
}

/**
 * Invite New User
 */
export class InviteUser extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.INVITE_USER;

  constructor(public payload: any) {
    super();
  }
}

export class InviteUserSuccess extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.INVITE_USER_SUCCESS;
  constructor() {
    super();
  }
}

export class InviteUserFailed extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.INVITE_USER_FAILED;
  constructor(public payload: any) {
    super();
  }
}

/**
 * Resend Invite
 */
export class ResendInvite extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.RESEND_INVITE;

  constructor(public payload: any) {
    super();
  }
}

export class ResendInviteSuccess extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.RESEND_INVITE_SUCCESS;
  constructor() {
    super();
  }
}

export class ResendInviteFailed extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.RESEND_INVITE_FAILED;
  constructor(public payload: any) {
    super();
  }
}

/**
 * Delete Invite
 */
export class DeleteInvite extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.DELETE_INVITE;

  constructor(public Id: string) {
    super();
  }
}

export class DeleteInviteSuccess extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.DELETE_INVITE_SUCCESS;

  constructor(public Id: any) {
    super();
  }
}

export class DeleteInviteFailed extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.DELETE_INVITE_FAILED;

  constructor(public payload: any) {
    super();
  }
}

export class SendPasswordRecoveryMail implements Action {
  readonly type = ApplicationUsersActionTypes.SEND_PASSWORD_RECOVERY_MAIL;

  constructor(public payload: SendPasswordRecoveryMailPayload) {}
}

export class SendPasswordRecoveryMailSuccess implements Action {
  readonly type =
    ApplicationUsersActionTypes.SEND_PASSWORD_RECOVERY_MAIL_SUCCESS;

  constructor(public payload: any) {}
}

export class SendPasswordRecoveryMailFailed implements Action {
  readonly type =
    ApplicationUsersActionTypes.SEND_PASSWORD_RECOVERY_MAIL_FAILED;

  constructor(public payload: any) {}
}

export class ChangeUserPassword extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.CHANGE_USER_PASSWORD;

  constructor(public payload: ChangeUserPasswordPayload) {
    super();
  }
}

export class ChangeUserPasswordSuccess extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.CHANGE_USER_PASSWORD_SUCCESS;

  constructor(public payload: any) {
    super();
  }
}

export class ChangeUserPasswordFailed extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.CHANGE_USER_PASSWORD_FAILED;

  constructor(public payload: any) {
    super();
  }
}

export class ImpersonateUser implements Action {
  readonly type = ApplicationUsersActionTypes.IMPERSONATE_USER;

  constructor(public payload: ImpersonateUserPayload) {}
}

export class ImpersonateUserSuccess implements Action {
  readonly type = ApplicationUsersActionTypes.IMPERSONATE_USER_SUCCESS;

  constructor(public payload: any) {}
}

export class ImpersonateUserFailed implements Action {
  readonly type = ApplicationUsersActionTypes.IMPERSONATE_USER_FAILED;

  constructor(public payload: any) {}
}

export class ReturnToSuperAdmin implements Action {
  readonly type = ApplicationUsersActionTypes.RETURN_TO_SUPER_ADMIN;

  constructor(public impersonatedId: string) {}
}

export class ReturnToSuperAdminSuccess implements Action {
  readonly type = ApplicationUsersActionTypes.RETURN_TO_SUPER_ADMIN_SUCCESS;
  constructor() {}
}

export class ReturnToSuperAdminFailed implements Action {
  readonly type = ApplicationUsersActionTypes.RETURN_TO_SUPER_ADMIN_FAILED;

  constructor(public payload: any) {}
}

/**
 * Create New User
 */
export class CreateNewUser extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.CREATE_NEW_USER;

  constructor(public payload: any) {
    super();
  }
}

/**
 * Create New User Success
 */
export class CreateNewUserSuccess extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.CREATE_NEW_USER_SUCCESS;

  constructor(public appId: any) {
    super();
  }
}

/**
 * Create New User Failed
 */
export class CreateNewUserFailed extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.CREATE_NEW_USER_FAILED;

  constructor(public payload: any) {
    super();
  }
}

/**
 * Valid User Email
 */
export class ValidUserEmail extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.VALID_USER_EMAIL;

  constructor(public payload: any) {
    super();
  }
}

/**
 * Valid User Email Success
 */
export class ValidUserEmailSuccess extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.VALID_USER_EMAIL_SUCCESS;

  constructor(public appId: any, public response: any) {
    super();
  }
}

/**
 * Valid User Email Failed
 */
export class ValidUserEmailFailed extends Reference implements Action {
  readonly type = ApplicationUsersActionTypes.VALID_USER_EMAIL_FAILED;

  constructor(public payload: any) {
    super();
  }
}

export class Reset implements Action {
  readonly type = ApplicationUsersActionTypes.RESET;

  constructor() {}
}

/**
 * Available types
 */
export type Actions =
  | LoadApplicationUsers
  | LoadApplicationUsersSuccess
  | LoadApplicationUsersFailed
  | LoadProducts
  | LoadProductsSuccess
  | LoadProductsFailed
  | LoadCompanyUsers
  | LoadEntityUsers
  | LoadCompanyUserSuccess
  | LoadCompanyUserFailed
  | AddExistingUser
  | AddExistingUserSuccess
  | AddExistinguserFailed
  | DeleteApplicationUser
  | DeleteApplicationUserSuccess
  | DeleteApplicationUserFailed
  | UpdateApplicationUser
  | UpdateApplicationUserSuccess
  | UpdateApplicationUserFailed
  | InviteUser
  | InviteUserSuccess
  | InviteUserFailed
  | ResendInvite
  | ResendInviteSuccess
  | ResendInviteFailed
  | DeleteInvite
  | DeleteInviteSuccess
  | DeleteInviteFailed
  | SendPasswordRecoveryMail
  | SendPasswordRecoveryMailSuccess
  | SendPasswordRecoveryMailFailed
  | ChangeUserPassword
  | ChangeUserPasswordSuccess
  | ChangeUserPasswordFailed
  | ImpersonateUser
  | ImpersonateUserSuccess
  | ImpersonateUserFailed
  | ReturnToSuperAdmin
  | ReturnToSuperAdminSuccess
  | ReturnToSuperAdminFailed
  | CreateNewUser
  | CreateNewUserSuccess
  | CreateNewUserFailed
  | ValidUserEmail
  | ValidUserEmailSuccess
  | ValidUserEmailFailed
  | Reset;
